<script setup lang="ts">
import GestionSites from '@/components/admin/GestionSites.vue'

definePage({
  meta: {
    id: 'admn.gestion',
    icon: 'mdi-tune',
    title: 'Paramètres globaux',
    drawerIndex: 98,
    requiresAuth: true,
    requiresAdmin: true,
  },
})

const theme = useTheme()
const activeTab = ref('sites')
</script>

<template>
  <v-card class="mx-4 my-4 page-card" rounded="xl" style="height: 85vh; display: flex; flex-direction: column;">

    <!-- ── Page header ─────────────────────────────────────────────── -->
    <div class="page-header px-5 pt-5 pb-3">
      <div class="d-flex align-center" style="gap: 12px;">
        <v-avatar color="primary" variant="tonal" size="44" rounded="lg">
          <v-icon icon="mdi-tune" size="26"/>
        </v-avatar>
        <div>
          <div class="text-h6 font-weight-bold" style="line-height: 1.2;">Paramètres globaux</div>
          <div class="text-caption text-medium-emphasis">Sites (réservé aux administrateurs)</div>
        </div>
      </div>
    </div>

    <v-divider/>

    <!-- ── Tabs ─────────────────────────────────────────────────────── -->
    <v-tabs v-model="activeTab" density="compact" class="px-2 pt-1" color="primary">
      <v-tab value="sites" prepend-icon="mdi-domain">Sites</v-tab>
    </v-tabs>

    <v-divider/>

    <!-- ── Content ──────────────────────────────────────────────────── -->
    <div style="flex: 1 1 auto; overflow: auto;">
      <v-window v-model="activeTab">
        <v-window-item value="sites">
          <GestionSites/>
        </v-window-item>
      </v-window>
    </div>

  </v-card>
</template>

<style scoped>
/* ── Page header ─────────────────────────── */
.page-header {
  background: v-bind('theme.global.name.value === "dark" ? "rgba(var(--v-theme-surface-variant), 0.25)" : "rgba(var(--v-theme-primary), 0.04)"');
}
</style>
